/**
 * (c) LBS logics
 *
 *     Mobile Business Technology GmbH
 *     4020 Linz, Austria
 *
 *     www.lbs-logics.com
 *
 *     created on 20190902 by Jan Brunner
 *     all rights reserved.
 */

import { Injectable } from '@angular/core';
import { Resetable } from '../../resetter/resetable';
import { Servicejob } from 'src/app/_model/servicejob';
import { IMSId } from 'src/app/_model/ims-object';

@Injectable()
export abstract class ServicejobsDaoService implements Resetable {
  public abstract saveServicejobs(servicejobs: Servicejob[]): Promise<void>;
  public abstract createServiceJob(servicejob: Servicejob): Promise<Servicejob>;
  public abstract getServicejobs(): Promise<Servicejob[]>;
  public abstract setNextTourJobEndNotDelivered(
    notDelivered: boolean,
  ): Promise<void>;
  public abstract getTourJobStatusEndNotDelivered(): Promise<boolean>;
  public abstract setFinisWithNextServicejobStatusChange(
    finish: boolean,
  ): Promise<void>;
  public abstract getFinishWithNextServicejobStatusChange(): Promise<boolean>;
  public abstract removeServicejob(id: IMSId): Promise<void>;
  public abstract deleteLocalServicejob(id: IMSId): Promise<void>;
  public abstract clearRemoteServicejobs();
  public abstract reset(): Promise<void>;
  public abstract clear(): Promise<void>;
}
